// import React, { useEffect, useState, useMemo } from "react";
// import { Download, RefreshCcw } from "lucide-react";
// import toast from "react-hot-toast";
// import { saveAs } from "file-saver";

// const SERVER_URL = process.env.REACT_APP_SERVER_URL;

// function ManageSales() {
//   const [sales, setSales] = useState([]);
//   const [filteredSales, setFilteredSales] = useState([]);
//   const [distributors, setDistributors] = useState([]);
//   const [filterType, setFilterType] = useState("all");
//   const [filterValue, setFilterValue] = useState("");

//   // ✅ Fetch all sales
//   const fetchSales = async () => {
//     try {
//       const res = await fetch(`${SERVER_URL}/api/sales`);
//       const data = await res.json();
//       if (res.ok) {
//         setSales(data);
//         setFilteredSales(data);
//         toast.success("Sales loaded successfully!");
//       } else {
//         toast.error(data.error || "Failed to fetch sales");
//       }
//     } catch (err) {
//       toast.error("Server error while fetching sales.");
//     }
//   };

//   // ✅ Fetch distributors for filter dropdown
//   const fetchDistributors = async () => {
//     try {
//       const res = await fetch(`${SERVER_URL}/api/distributors`);
//       const data = await res.json();
//       if (res.ok) setDistributors(data);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     fetchSales();
//     fetchDistributors();
//   }, []);

//   // ✅ Filter logic
//   useEffect(() => {
//     if (filterType === "all" || !filterValue) {
//       setFilteredSales(sales);
//       return;
//     }

//     const results =
//       filterType === "distributor"
//         ? sales.filter(
//             (s) => s.distributor?.name?.toLowerCase() === filterValue.toLowerCase()
//           )
//         : sales.filter(
//             (s) => s.product?.toLowerCase() === filterValue.toLowerCase()
//           );

//     setFilteredSales(results);
//   }, [filterType, filterValue, sales]);

//   // ✅ Calculate total BV (always shown at bottom, even when filtered)
//   const totalBV = useMemo(() => {
//     return filteredSales.reduce((sum, s) => sum + (s.totalBV || 0), 0);
//   }, [filteredSales]);

//   // ✅ Export as CSV
//   const handleExportCSV = () => {
//     if (!filteredSales.length) return toast.error("No data to export.");

//     const headers = ["Distributor", "Product", "Quantity", "BV", "Date"];
//     const rows = filteredSales.map((s) => [
//       s.distributor?.name || "N/A",
//       s.product,
//       s.quantity,
//       s.bv,
//       new Date(s.createdAt).toLocaleString(),
//     ]);

//     // Add total BV summary at the end of the CSV
//     rows.push([]);
//     rows.push(["", "", "", "Total BV", totalBV]);

//     const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");
//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     saveAs(blob, "sales_report.csv");
//     toast.success("Sales exported as CSV!");
//   };

//   return (
//     <div className="p-6 bg-white rounded-xl shadow-md">
//       {/* Header + Filters */}
//       <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-5 gap-4">
//         <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
//           Manage Sales
//           <RefreshCcw
//             onClick={fetchSales}
//             className="cursor-pointer text-blue-600 hover:rotate-180 transition-transform"
//             size={20}
//           />
//         </h2>

//         <div className="flex gap-3">
//           <select
//             className="border border-gray-300 rounded-lg px-3 py-2"
//             value={filterType}
//             onChange={(e) => {
//               setFilterType(e.target.value);
//               setFilterValue("");
//             }}
//           >
//             <option value="all">All Sales</option>
//             <option value="distributor">By Distributor</option>
//             <option value="product">By Product</option>
//           </select>

//           {filterType === "distributor" && (
//             <select
//               className="border border-gray-300 rounded-lg px-3 py-2"
//               value={filterValue}
//               onChange={(e) => setFilterValue(e.target.value)}
//             >
//               <option value="">Select Distributor</option>
//               {distributors.map((d) => (
//                 <option key={d._id} value={d.name}>
//                   {d.name}
//                 </option>
//               ))}
//             </select>
//           )}

//           {filterType === "product" && (
//             <input
//               type="text"
//               placeholder="Enter product name..."
//               className="border border-gray-300 rounded-lg px-3 py-2"
//               value={filterValue}
//               onChange={(e) => setFilterValue(e.target.value)}
//             />
//           )}

//           <button
//             onClick={handleExportCSV}
//             className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg"
//           >
//             <Download size={16} />
//             Export CSV
//           </button>
//         </div>
//       </div>

//       {/* Sales Table */}
//       <div className="overflow-x-auto rounded-lg border border-gray-200">
//         <table className="w-full text-sm text-left">
//           <thead className="bg-gray-100 text-gray-700 uppercase">
//             <tr>
//               <th className="px-4 py-2">Distributor</th>
//               <th className="px-4 py-2">Product</th>
//               <th className="px-4 py-2">Quantity</th>
//               <th className="px-4 py-2">BV</th>
//               <th className="px-4 py-2">Date</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredSales.map((s) => (
//               <tr key={s._id} className="border-b hover:bg-gray-50">
//                 <td className="px-4 py-2">{s.distributor?.name || "N/A"}</td>
//                 <td className="px-4 py-2">{s.product}</td>
//                 <td className="px-4 py-2">{s.quantity}</td>
//                 <td className="px-4 py-2">{s.bv}</td>
//                 <td className="px-4 py-2">
//                   {new Date(s.createdAt).toLocaleDateString()}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {filteredSales.length === 0 && (
//           <div className="text-center text-gray-500 py-8">
//             No sales found for the selected filter.
//           </div>
//         )}
//       </div>

//       {/* Total BV Summary */}
//       <div className="mt-5 flex justify-end">
//         <div className="text-right bg-blue-50 border border-blue-200 px-4 py-2 rounded-lg">
//           <strong className="text-blue-700">Total BV Displayed:</strong>{" "}
//           <span className="font-semibold text-blue-800">
//             {totalBV.toLocaleString()} BV
//           </span>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ManageSales;

import React, { useEffect, useState, useMemo } from "react";
import { Download, RefreshCcw, Calendar } from "lucide-react";
import toast from "react-hot-toast";
import { saveAs } from "file-saver";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

function ManageSales() {
  const [sales, setSales] = useState([]);
  const [filteredSales, setFilteredSales] = useState([]);
  const [distributors, setDistributors] = useState([]);
  const [filterType, setFilterType] = useState("all");
  const [filterValue, setFilterValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // ✅ Fetch all sales
  const fetchSales = async () => {
    try {
      const res = await fetch(`${SERVER_URL}/api/sales`);
      const data = await res.json();
      if (res.ok) {
        setSales(data);
        setFilteredSales(data);
        toast.success("Sales loaded successfully!");
      } else {
        toast.error(data.error || "Failed to fetch sales");
      }
    } catch (err) {
      toast.error("Server error while fetching sales.");
    }
  };

  // ✅ Fetch distributors for dropdown
  const fetchDistributors = async () => {
    try {
      const res = await fetch(`${SERVER_URL}/api/distributors`);
      const data = await res.json();
      if (res.ok) setDistributors(data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSales();
    fetchDistributors();
  }, []);

  // ✅ Filtering logic (includes date range)
  useEffect(() => {
    let results = [...sales];

    // Filter by distributor or product
    if (filterType === "distributor" && filterValue) {
      results = results.filter(
        (s) => s.distributor?.name?.toLowerCase() === filterValue.toLowerCase()
      );
    } else if (filterType === "product" && filterValue) {
      results = results.filter(
        (s) => s.product?.toLowerCase() === filterValue.toLowerCase()
      );
    }

    // Filter by date range
    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      if (from > to) {
        toast.error("Start date cannot be later than end date.");
      } else {
        results = results.filter((s) => {
          const saleDate = new Date(s.createdAt);
          return saleDate >= from && saleDate <= to;
        });
      }
    }

    setFilteredSales(results);
  }, [filterType, filterValue, fromDate, toDate, sales]);

  // ✅ Calculate total BV
  const totalBV = useMemo(
    () => filteredSales.reduce((sum, s) => sum + (s.totalBV || 0), 0),
    [filteredSales]
  );

  const totalP = useMemo(
    () => filteredSales.reduce((sum, s) => sum + (s.totalPrice || 0), 0),
    [filteredSales]
  );

  // ✅ Export as CSV
  const handleExportCSV = () => {
    if (!filteredSales.length) return toast.error("No data to export.");

    const headers = ["Distributor", "Product", "Quantity", "BV", "Date"];
    const rows = filteredSales.map((s) => [
      s.distributor?.name || "N/A",
      s.product,
      s.quantity,
      s.bv,
      new Date(s.createdAt).toLocaleString(),
    ]);

    // Add total BV summary at the end
    rows.push([]);
    rows.push(["", "", "", "Total BV", totalBV]);

    const csvContent = [headers, ...rows].map((e) => e.join(",")).join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "sales_report.csv");
    toast.success("Sales exported as CSV!");
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow-md">
      {/* Header + Filters */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-5 gap-4">
        <h2 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
          Manage Sales
          <RefreshCcw
            onClick={fetchSales}
            className="cursor-pointer text-blue-600 hover:rotate-180 transition-transform"
            size={20}
          />
        </h2>

        <div className="flex flex-wrap items-center gap-3">
          {/* Filter Type */}
          <select
            className="border border-gray-300 rounded-lg px-3 py-2"
            value={filterType}
            onChange={(e) => {
              setFilterType(e.target.value);
              setFilterValue("");
            }}
          >
            <option value="all">All Sales</option>
            <option value="distributor">By Distributor</option>
            <option value="product">By Product</option>
          </select>

          {/* Distributor Dropdown */}
          {filterType === "distributor" && (
            <select
              className="border border-gray-300 rounded-lg px-3 py-2"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
            >
              <option value="">Select Distributor</option>
              {distributors.map((d) => (
                <option key={d._id} value={d.name}>
                  {d.name}
                </option>
              ))}
            </select>
          )}

          {/* Product Input */}
          {filterType === "product" && (
            <input
              type="text"
              placeholder="Enter product name..."
              className="border border-gray-300 rounded-lg px-3 py-2"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
            />
          )}

          {/* Date Filters */}
          <div className="flex items-center gap-2">
            <Calendar className="text-gray-500" size={18} />
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="border border-gray-300 rounded-lg px-2 py-2 text-sm"
            />
            <span className="text-gray-500">to</span>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="border border-gray-300 rounded-lg px-2 py-2 text-sm"
            />
          </div>

          {/* Export Button */}
          <button
            onClick={handleExportCSV}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg"
          >
            <Download size={16} />
            Export CSV
          </button>
        </div>
      </div>

      {/* Sales Table */}
      <div className="overflow-x-auto rounded-lg border border-gray-200">
        <table className="w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700 uppercase">
            <tr>
              <th className="px-4 py-2">Distributor</th>
              <th className="px-4 py-2">Product</th>
              <th className="py-3 px-4">Price</th>
              <th className="px-4 py-2">Quantity</th>
              <th className="px-4 py-2">BV</th>
              <th className="px-4 py-2">Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredSales.map((s) => (
              <tr key={s._id} className="border-b hover:bg-gray-50">
                <td className="px-4 py-2">{s.distributor?.name || "N/A"}</td>
                <td className="px-4 py-2">{s.product}</td>
                <th className="py-4 px-2">{s.totalPrice} KES</th>
                <td className="px-4 py-2">{s.quantity}</td>
                <td className="px-4 py-2">{s.bv}</td>
                <td className="px-4 py-2">
                  {new Date(s.createdAt).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {filteredSales.length === 0 && (
          <div className="text-center text-gray-500 py-8">
            No sales found for the selected filter.
          </div>
        )}
      </div>

      {/* Total BV Summary */}
      <div className="mt-5 flex justify-end gap-4 sticky bottom-0">
        <div className="text-right bg-green-50 border border-green-200 px-4 py-2 rounded-lg">
          <strong className="text-green-700">Total Sales:</strong>{" "}
          <span className="font-semibold text-green-800">
            {totalP.toLocaleString()} KES
          </span>
        </div>
        <div className="text-right bg-blue-50 border border-blue-200 px-4 py-2 rounded-lg">
          <strong className="text-blue-700">Total BV Displayed:</strong>{" "}
          <span className="font-semibold text-blue-800">
            {totalBV.toLocaleString()} BV
          </span>
        </div>
      </div>
    </div>
  );
}

export default ManageSales;
